const TRANSACTION = {
    GARAGE: {
        label: 'garage',
        timeSaved: 1200,
    },
    TRADEIN: {
        label: 'tradein',
        timeSaved: 2400,
    },
    FINANCE: {
        label: 'finance',
        timeSaved: 1800,
        // XXX TODO: re-enable reservation
        // },
        // RESERVE: {
        //     label: 'reserve',
        //     timeSaved: 1200
    },
};

export default TRANSACTION;
